import Side from './Side';

export default class RollarmSide extends Side {
  constructor(threekitApi, options = {}) {
    super(threekitApi, options);
    this._key = 'rollArm';
  }
}
